import { render, staticRenderFns } from "./MHeader.vue?vue&type=template&id=8635b5d0&scoped=true"
import script from "./MHeader.vue?vue&type=script&lang=js"
export * from "./MHeader.vue?vue&type=script&lang=js"
import style0 from "./MHeader.vue?vue&type=style&index=0&id=8635b5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8635b5d0",
  null
  
)

export default component.exports